import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { InsuranceCompanyCode } from '../../../models/insurance-company-code.enum';
import { FieldType } from '../../../models/field-type';
import { FormFactoryService } from '../../../services/form-factory.service';
import { ControlChange } from '../../../../core/models/control-change.model';
import { DiscountCodesService } from '../../../../core/services/impl/section-services/discount-codes/discount-codes.service';
import { UrlParamsService } from '../../../../core/services/impl/url-params.service';

@Component({
  selector: 'app-discount-codes-section',
  templateUrl: './discount-codes-section.component.html',
  styleUrls: []
})
export class DiscountCodesSectionComponent extends SectionBase implements OnInit {

  get sectionVisible(): boolean {
    return this.urlParamsService.isLoggedUserIdParam;
  }

  get TUZOptions(): any {
    return [
      {key: '0', value: '0'},
      {key: '5', value: '5'}
    ];
  }

  get EuroinsOptions(): any {
    return [...Array(19).keys()].reverse().map(value => ({
      key: value + '',
      value: value + ''
    }));
  }

  insuranceCompaniesWithDiscountCodes = [
    InsuranceCompanyCode.BENEFIA,
    InsuranceCompanyCode.EUROINS,
    InsuranceCompanyCode.GENERALI,
    InsuranceCompanyCode.LINK4,
    InsuranceCompanyCode.MTU,
    InsuranceCompanyCode.PROAMA,
    InsuranceCompanyCode.TUZ,
    InsuranceCompanyCode.DIRECT,
  ];

  constructor(private discountCodesService: DiscountCodesService,
              private urlParamsService: UrlParamsService) {
    super();
  }

  ngOnInit() {
    this.initBean();
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
  }

  createConfig(): void {
    this.formConfig = {
      formKey: 'DISCOUNT_CODES_SECTION',
      fieldsConfig: <any>this.insuranceCompaniesWithDiscountCodes.map((icCode: InsuranceCompanyCode) => {
        if (icCode === InsuranceCompanyCode.TUZ) {
          return {
            fieldKey: icCode,
            caption: `DISCOUNT_CODES_SECTION.FORM_FIELDS.${icCode}`,
            type: FieldType.Select,
            options: {
              item: 'key',
              label: {label: 'key'},
              items: this.TUZOptions
            },
            select: {
              dropdownPosition: 'bottom',
              multiple: false,
              searchable: true,
            }
          }
        } else if (icCode === InsuranceCompanyCode.EUROINS) {
          return {
            fieldKey: icCode,
            caption: `DISCOUNT_CODES_SECTION.FORM_FIELDS.${icCode}`,
            type: FieldType.Select,
            options: {
              item: 'key',
              label: {label: 'key'},
              items: this.EuroinsOptions
            },
            select: {
              dropdownPosition: 'bottom',
              multiple: false,
              searchable: true,
            }
          }
        } else {
          return {
            fieldKey: icCode,
            caption: `DISCOUNT_CODES_SECTION.FORM_FIELDS.${icCode}`,
            type: FieldType.TextField,
            properties: {
              textTransform: {
                type: 'uppercase'
              },
            }
          }
        }
      })
    }
  }

  buildForm(): void {
    this.formFactoryService = new FormFactoryService(this.formConfig, this.bean);
    this.formFactoryService.buildFormGroup(this.formGroup);
  }

  initBean(): void {
    this.bean = this.discountCodesService.discounts;
  }

  initControlsChanges(): void {
    let controlsChanges: ControlChange[] = this.insuranceCompaniesWithDiscountCodes.map(icCode => ({
      controlName: icCode,
      behaviour: value => this.discountCodesService.changeDiscountCode(icCode, value)
    }));
    this.handleControlsState(...controlsChanges);
  }

}
